import React, { useEffect } from 'react';
import { Grid, Button, Box } from "@mui/material";
import { styles } from "./styles";
import { styles as inputStyles } from "common/inputStyles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { CSVLink } from "react-csv";
import { Colors } from "assets/colors";

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}

interface TipPushStatusTableHeaderProps {
  //actionButtons: Array<ActionButtons>;
  searchVal: string;
  setSearchVal: Function;
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
  setShowCont?: any;
  setFormattedData?: any;
  setCheckedData?: any
  formattedData?: any;
  checkedData?: any;
}

const TipPushStatusTableHeader: React.FC<TipPushStatusTableHeaderProps> = ({ searchVal, setCheckedData, formattedData, setFormattedData, checkedData, setShowCont, setSearchVal, data, tabs, withFilter, csvLabel }) => {
  
  const transformUserRoles = (arr: any) => {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = { ...obj };
        if (transformedObj.hasOwnProperty('objectName')) {
          delete transformedObj['objectName'];
        }
        if (transformedObj.hasOwnProperty('payload')) {
          delete transformedObj['payload'];
        }
        if (transformedObj.hasOwnProperty('moduleName')) {
          delete transformedObj['moduleName'];
        }
        if (transformedObj.hasOwnProperty('numberFormat')) {
          delete transformedObj['numberFormat'];
        }
        if (transformedObj.hasOwnProperty('permissionCount')) {
          delete transformedObj['permissionCount'];
        }
        if (transformedObj.hasOwnProperty('recordNumber')) {
          delete transformedObj['recordNumber'];
        }
        if (transformedObj.hasOwnProperty('obsNumber')) {
          delete transformedObj['obsNumber'];
        }
        if (transformedObj.hasOwnProperty('Event Timestamp')) {
          delete transformedObj['Event Timestamp'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
        //console.log(transformedObj)
      }
    });

    if (transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {
    if (checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
      console.log(transformedArray)
      let rArray: any = [];
      let eventRptData: any = [];
      for (var i = 0; i < transformedArray.length; i++) {
        let eventorderObj: any = {}; 
        let newerrVal: any = transformedArray[i]["Error Message"];
        newerrVal = JSON.stringify(newerrVal.toString().replace(/,/g, ""));
      
        eventorderObj["Error Message"] = newerrVal;
        eventorderObj["Retry Attempts"] = transformedArray[i]["Retry Attempts"];
        eventorderObj["Status"] = transformedArray[i]["Status"];
        eventorderObj["Created By Process"] = transformedArray[i]["Created By Process"];
        eventorderObj["Creation Date"] = transformedArray[i]["Creation Date"];
        eventorderObj["Truck Number"] = transformedArray[i]["Truck Number"];
        eventorderObj["Device ID"] = transformedArray[i]["Device Name"];
        eventorderObj["Tag ID"] = transformedArray[i]["Tag Id"];
        eventorderObj["Address"] = transformedArray[i]["Address"];
        eventorderObj["Event Type"] = transformedArray[i]["Event Type"];
        eventorderObj["Event Date"] = transformedArray[i]["Event Date"];

        eventRptData.push(eventorderObj);
      }
      setFormattedData(eventRptData);
    }
  }, [checkedData]);

  useEffect(() => {
    if (data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  const OpenContainer = (e: any) => {
    e.preventDefault();
     setShowCont(true);
  }

  return (
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }} style={{ margin: '0px' }}>
      {
        tabs &&
        <Grid sx={styles.buttonContainer}>
          {tabs.map((t, i) =>
            <Button key={i} sx={{ ...styles.buttons, ...t.buttonStyle, marginRight: 0 }} onClick={() => t.onClickHandler()}>
              {t.icon && t.icon}
              {t.label}
            </Button>
          )}
        </Grid>
      }
      <Grid sx={styles.buttonContainer}>
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel : 'download.csv'}>
          <Button sx={{ ...styles.buttons, backgroundColor: Colors.Purple }}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        <Box sx={inputStyles.searchContainer}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem" }} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default TipPushStatusTableHeader;
